import {useContext} from "react";
import {TimelineFrameDataContext} from "../../../../TimelineFramePage";
import {TYPE_FIMLAB} from "../../../../../../definitions/TimelineItems";


export const TimelineFrameContentLabResearchWrapper = ({children}) => {

    const { data } = useContext(TimelineFrameDataContext);

    if (data.type !== TYPE_FIMLAB) {
        return <></>
    }

    return (
        <>{children}</>
    )
}